export default __webpack_public_path__ + "static/ak-cached/24h/media/chr_routerOld.f9101a3e.png";